import {DomainEvent} from '../../model/domain-event.model';
import {PaymentStatus} from '@features/payment/domain/model/payment.model';

export {PaymentStatus};

export interface PaymentStatusChangedPayload {
  orderId: string;
  status: PaymentStatus;
  amount?: number;
  errorCode?: string;
}

export class PaymentStatusChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(public readonly payload: PaymentStatusChangedPayload) {
  }
}
